import {
  Storage,
  TransitEnterexit,
  CallMade,
  AccountTree,
  BarChart,
  Build,
  Cloud,
  Code,
  Dashboard,
  DataUsage,
  DeviceHub,
  Folder,
  Functions,
  Input,
  Label,
  Link,
  LocalShipping,
  Memory,
  Policy,
  Public,
  Security,
  Share,
  Star,
  SwapHoriz,
  Widgets,
} from '@material-ui/icons';

/**
 * Curated set of ~25 MUI icon names usable as characteristic icons.
 * Shared by CharacteristicIconPicker (grid) and AppNode (badge rendering).
 * Adding a new icon: add it to this map and to the curated list below.
 */
export const CHARACTERISTIC_ICONS = {
  Storage,
  TransitEnterexit,
  CallMade,
  AccountTree,
  BarChart,
  Build,
  Cloud,
  Code,
  Dashboard,
  DataUsage,
  DeviceHub,
  Folder,
  Functions,
  Input,
  Label,
  Link,
  LocalShipping,
  Memory,
  Policy,
  Public,
  Security,
  Share,
  Star,
  SwapHoriz,
  Widgets,
};

export const CHARACTERISTIC_ICON_NAMES = Object.keys(CHARACTERISTIC_ICONS);

/** Resolve an icon name to its component, falling back to a star if not found. */
export const resolveIcon = (name) => CHARACTERISTIC_ICONS[name] || Star;
